<template>
    <section
        id="virtual-staging-by-human"
        class="xl:py-20 lg:h-[920px] h-[720px] flex flex-col items-center justify-center relative"
    >
        <picture class="w-full">
            <source
                srcset="https://revi.rvstatic.com/aihomedesign/images-v3/Virtual-Staging/VSHuman/Large/VSHuman.webp"
                media="(min-width: 900px)"
                class="w-full"
                
            />
            <NuxtImg
                width="100"
                height="100"
                src="https://revi.rvstatic.com/aihomedesign/images-v3/Virtual-Staging/VSHuman/Small/VSHuman.png"
                class="w-full"
                :alt="$t('pages_VS_VsManual_title')"
            />
        </picture>

        <div
            class="container space-y-8 flex flex-col justify-center items-center absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
        >
            <div>
                <h2 class="text-gray-100 mb-2 font-bold xl:text-title-xl text-title-lg text-center">
                    {{ $t("pages_VS_VsManual_title") }}
                </h2>
                <p class="text-body-md text-gray-100 text-center">
                    {{ $t("pages_VS_VsManual_desc_1") }}
                </p>
            </div>

            <div class="grid xl:grid-cols-4 grid-cols-2 gap-2 xl:w-fit w-full">
                <template v-for="manualItem in vsManualItems">
                    <div
                        class="py-4 h-[120px] px-2 bg-gray-100/10 backdrop-blur-md rounded-lg xl:w-[200px] text-body-md text-gray-100 text-center flex flex-col items-center justify-center"
                    >
                        <Icon :name="manualItem.icon" class="mb-1 lg:size-8 size-6" />
                        <p class="mb-1">
                            {{ manualItem.text }}
                        </p>
                        <p class="text-body-sm text-gray-100">{{ manualItem.subtitle }}</p>
                    </div>
                </template>
            </div>

            <div class="text-center space-y-2">
                <!-- <p class="text-title-sm font-bold text-gray-100">{{ $t("pages_VS_VsManual_asLowAs") }}</p> -->

                <div class="bg-gray-100/10 text-gray-100 backdrop-blur-md flex space-x-1 items-center rounded-lg p-4">
                    <b class="text-title-md">{{ $t("pages_VS_VsManual_perImage_price") }}</b>
                    <p class="text-body-sm">{{ $t("pages_VS_VsManual_perImage") }}</p>
                </div>

                <!-- <p class="text-gray-500">{{ $t("pages_VS_VsManual_forSubscribers") }}</p> -->
            </div>

            <AppButton
                color="white"
                variant="primary"
                class="block w-fit mt-8"
                @click="handleButtonClick"
                id="virtualstaging-virtualstagingbyhuman-ordernow-button"
            >
                {{ $t("global_orderNow") }}
            </AppButton>
        </div>
    </section>
</template>

<script setup lang="ts">
import { useSubAccountStore } from "~/modules/sub-account/store";
import { useUserStore } from "~/store/global/user.store";
import type { IExploreItems } from "~/types/components/landings.type";

type TVsManualItems = Omit<IExploreItems, "link" | "image"> & { icon: string; subtitle?: string };

const { t } = useI18n();

const vsManualItems: TVsManualItems[] = [
    {
        icon: "tabler:tools",
        text: t("pages_VS_VsManual_feature_1"),
    },
    {
        icon: "tabler:versions",
        text: t("pages_VS_VsManual_feature_2"),
    },
    {
        icon: "tabler:clock",
        text: t("pages_VS_VsManual_feature_3"),
        subtitle: t("pages_VS_VsManual_feature_3_subtitle"),
    },
    {
        icon: "tabler:box",
        text: t("pages_VS_VsManual_feature_4"),
    },
];

const { userData } = storeToRefs(useUserStore());

const { subAccountData } = storeToRefs(useSubAccountStore());

async function handleButtonClick() {
    if (userData.value.domain === "subaccount") {
        subAccountData.value.showState = true;
        subAccountData.value.type = "vs-manual-limited";
    } else {
        await navigateTo("/dashboard/upload-photo/service-vs-manual");
    }
}
</script>
